import {useState} from 'react';
import {API} from '../lib/api';
import {browserScope} from '../lib/sessionScope';

// The page is keyed by account so neither preferences nor pending data cross logins.
export default function useClientListView(userId,tenantId) {
  const key=`autotu:client-view:v1:${JSON.stringify(browserScope(API,userId,tenantId))}`;
  const [preference,setPreference]=useState(()=>{
    try {return {view:localStorage.getItem(key)==='compact'?'compact':'extended',notice:''};}
    catch {return {view:'extended',notice:'La preferenza salvata non è disponibile. Puoi comunque cambiare vista.'};}
  });
  const setView=view=>{
    if(!['compact','extended'].includes(view))return;
    try {localStorage.setItem(key,view);setPreference({view,notice:''});}
    catch {setPreference({view,notice:'Vista cambiata per questa sessione. Non è stato possibile ricordare la scelta su questo browser.'});}
  };
  return {...preference,setView};
}
